<template>
  <div class="download">
    <div class="client-box" style="height:calc(100vh - 72px);">
      <div class="text-box">
        <div class="title" style="color:#fff;">
          <span>海昇云课堂</span>
          <img src="@/common/img/teacher_tip.png" class="tip">
        </div>
        <div class="btn" @click="download">客户端下载</div>
      </div>
      <img src="@/common/img/download_back2.png" width="40%">
    </div>
    <div class="mobile-box">
      <img src="@/common/img/download_back3.png" width="40%">
      <div class="text-box" style="margin-right:0;margin-left:7vw;">
        <div class="title">
          <span>海昇云课堂</span>
          <img src="@/common/img/student_tip.png" class="tip">
          <qriously :value="mobileUrl" :size="200" class="qriously" v-show="codeShow" />
        </div>
        <div class="btn" @click="codeShow=!codeShow">移动端下载</div>
      </div>
    </div>
    <div class="client-box" style="background:#E7F2FD;">
      <div class="text-box">
        <div class="title">
          <span>流畅上课 不再卡顿</span>
        </div>
        <div class="text">更稳定清晰的画质，上课卡顿情况大幅</div>
        <div class="text">减少，让你的上课体验更“爽”</div>
      </div>
      <img src="@/common/img/download_back4.png" width="30%">
    </div>
    <div class="mobile-box">
      <img src="@/common/img/download_back5.png" width="30%">
      <div class="text-box" style="margin-right:0;margin-left:7vw;">
        <div class="title">
          <span>支持课堂内举手互动</span>
        </div>
        <div class="text">老师发起举手请求后，可支持最多6名学生同</div>
        <div class="text">时通过语音回答问题，互动课堂更高效</div>
      </div>
    </div>
    <div class="client-box" style="background:#E7F2FD;">
      <div class="text-box">
        <div class="title" style="padding-right:0;">
          <span>全新一站式沉浸式学习体验</span>
        </div>
        <div class="text">看直播、看视频、做题目、下载资料等所有</div>
        <div class="text">学习体验都能在客户端内一站式沉浸完成，</div>
        <div class="text">构建无干扰学习环境</div>
      </div>
      <img src="@/common/img/download_back6.png" width="30%">
    </div>
    <!-- 下载进度条 -->
    <!-- <el-dialog title="正在下载，请稍候..." :visible.sync="progressFlag" width="500px" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false">
      <el-progress :percentage="downloadPercent"></el-progress>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeShow: false,
      // progressFlag: false,
      // downloadPercent: 0,// 下载进度
      mobileUrl: "https://app.zxxuetang.com/rest/v/apk/download/hisonlive"
    }
  },
  created() { },
  mounted() { },
  methods: {
    // 下载
    download() {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = "https://update.zxxuetang.com/download/flavor/live/latest/windows_64";
      link.setAttribute("download", "海昇云课堂.exe");
      document.body.appendChild(link);
      link.click(); //点击下载
      URL.revokeObjectURL(link.href); // 释放URL对象
      document.body.removeChild(link); //下载完成移除元素

      // // let loading = this.$loading({
      // //   lock: true,
      // //   text: '正在下载，请稍候...',
      // //   spinner: 'el-icon-loading',
      // //   background: 'rgba(255, 255, 255, 0.5)'
      // // });
      // this.downloadPercent = 0;
      // this.progressFlag = true;
      // var xhr = new XMLHttpRequest();
      // xhr.open("GET", "https://update.zxxuetang.com/download/flavor/live/latest/windows_32", true);
      // xhr.responseType = 'blob';
      // xhr.addEventListener('progress', event => {
      //   // 计算出下载进度百分比
      //   const percent = ((event.loaded / event.total) * 100).toFixed(2);
      //   this.downloadPercent = parseInt(percent);
      //   if (this.downloadPercent >= 100) {
      //     this.progressFlag = false;
      //   }
      // }, false);
      // xhr.onload = function () {
      //   // loading.close();
      //   var url = URL.createObjectURL(xhr.response)//传入返回的bobl对象
      //   var a = document.createElement('a');
      //   a.href = url
      //   a.download = "海昇云课堂.exe";//修改的文件名
      //   a.click()
      // }
      // xhr.send();
    }
  }
}
</script>

<style scoped lang="stylus">
.download {
  margin-top: 72px;
  width: 100%;

  .client-box {
    width: 100%;
    height: 47vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/common/img/download_back1.png');
    background-size: 100% 100%;
  }

  .mobile-box {
    width: 100%;
    height: 35vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }

  .text-box {
    margin-right: 5vw;
    text-align: center;

    .title {
      font-size: 3.4vw;
      margin-bottom: 2vw;
      color: #1C82E7;
      padding-right: 7vw;
      position: relative;

      .tip {
        width: 6vw;
        position: absolute;
        right: 0;
        top: -1vw;
      }

      .qriously {
        position: absolute;
        left: 0;
        bottom: -2vw;
        background: #fff;
        padding: 0 20px;
      }
    }

    .btn {
      width: 12vw;
      height: 3vw;
      line-height: 3vw;
      border-radius: 3vw;
      background: #fff;
      font-size: 1.6vw;
      color: #1C82E7;
      font-weight: bold;
      border: 1px solid #1C82E7;
      cursor: pointer;
    }

    .text {
      font-size: 1.6vw;
      color: #787878;
      line-height: 2em;
      text-align: left;
    }
  }
}
</style>